/**
 * Protected Route Component
 * Wraps routes that require authentication.
 * Billing/trial blocking is handled by BlockedAccountOverlay in InternalLayout.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import BrandLoader from '@/components/BrandLoader';

export default function ProtectedRoute({ children }) {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return <BrandLoader fullscreen label="VERIFICANDO" />;
    }

    if (!isAuthenticated) {
        // Redirect to login, saving the attempted location
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}
